import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
} from "@mui/material";

export default function ResetCredentialsModal({
    open,
    onClose,
    onSubmit,
    password,
    setPassword,
}) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: "35vw",
                },
            }}
        >
            <DialogTitle sx={{ color: "#ffffff" }}>
                Reset Credentials
            </DialogTitle>

            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="New Password"
                    type="password"
                    fullWidth
                    variant="outlined"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    sx={{
                        input: {
                            color: "#d1d5db",
                        },
                        "& label": {
                            color: "#d1d5db",
                        },
                        "& label.Mui-focused": {
                            color: "#ffffff",
                        },
                        "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                                borderColor: "#d1d5db",
                            },
                            "&:hover fieldset": {
                                borderColor: "#d1d5db",
                            },
                            "&.Mui-focused fieldset": {
                                borderColor: "#ffffff",
                            },
                        },
                    }}
                />
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                    sx={{
                        backgroundColor: "transparent",
                        color: "#d1d5db",
                        "&:hover": {
                            backgroundColor: "transparent",
                        },
                    }}
                >
                    Cancel
                </Button>

                <Button
                    onClick={onSubmit}
                    variant="contained"
                    sx={{
                        backgroundColor: "#d1d5db",
                        color: "#1f2937",
                        "&:hover": {
                            backgroundColor: "#9ca3af",
                        },
                    }}
                >
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
}
